import { SimpleEntityGridColumn } from "src/app/components/grid/SimpleEntityGrid";
import ActionButton from "../../ActionButton/ActionButton";
import { KTSVG } from "src/_metronic/helpers/components/KTSVG";
import { Order } from "src/app/types/orders/order";
import { startCase } from "lodash";
import moment from "moment";
import { filterParams } from "../../grid/GridHelpers";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "src/_metronic/helpers/AssetHelpers";

export default function onSiteGridBoostColumns(
    formatMessage: any,
    action: (modal: "edit", data: Order) => void
): Array<SimpleEntityGridColumn> {
    return [
        {
            field: "id",
            filter: "agNumberColumnFilter",
            cellClass: "number-cell",
            minWidth: 60,
            maxWidth: 60,
            hide: true,
        },
        {
            field: "publishedAt",
            filter: "agDateColumnFilter",
            comparator: (date1, date2) => {
                const timeStamp1 = new Date(
                    moment(date1, "DD/MM/YYYY").format("YYYY-MM-DD")
                ).getTime();
                const timeStamp2 = new Date(
                    moment(date2, "DD/MM/YYYY").format("YYYY-MM-DD")
                ).getTime();
                return timeStamp1 - timeStamp2;
            },
            headerName: formatMessage({ id: "content.grid.col.publishedAt" }),
            valueGetter: ({ data }: any) => moment(data.publishedAt).format("DD/MM/YYYY"),
            filterParams,
            minWidth: 90,
            maxWidth: 90,
        },
        {
            field: "indexed",
            minWidth: 80,
            maxWidth: 80,
            headerName: formatMessage({ id: "content.grid.col.indexed" }),
            filter: "agSetColumnFilter",
            valueGetter: ({ data }: any) => {
                return data?.indexed;
            },
            cellRenderer: (params: { data: any }) => {
                const { data } = params;
                if (data?.indexed === 0 || data?.indexed !== 1) {
                    return (
                        <SVG
                            src={toAbsoluteUrl("/media/icons/duotune/general/gen034.svg")}
                            className="svg-icon-danger"
                        />
                    );
                }
                if (data?.indexed === 1) {
                    return (
                        <SVG
                            src={toAbsoluteUrl("/media/icons/duotune/general/gen037.svg")}
                            className="svg-icon-valid"
                        />
                    );
                }
            },
            filterParams,
        },
        {
            field: "keyword",
            autoHeight: true,
            headerName: formatMessage({ id: "content.grid.col.keyword" }),
            valueGetter: ({ data }: any) => {
                return data?.keywords;
            },
            cellRenderer: ({ data }: any) => (
                <div className="thematic-react-tag-wrapper gap-2 pb-2 pt-2">
                    {data?.keywords?.map((category: string, index: number) => (
                        <div key={index} className="thematic-react-tag">
                            {category}
                        </div>
                    ))}
                </div>
            ),
            minWidth: 250,
            maxWidth: 250,
        },
        {
            field: "title",
            headerName: formatMessage({ id: "content.grid.col.title" }),
        },
        {
            field: "metaTitle",
            headerName: formatMessage({ id: "content.grid.col.meta-title" }),
        },
        {
            field: "metaDescription",
            headerName: formatMessage({ id: "content.grid.col.meta-description" }),
        },
        {
            field: "url",
            headerName: formatMessage({ id: "urls.grid.col.url" }),
            filter: "agTextColumnFilter",
            hide: true,
        },
        {
            field: "actions",
            minWidth: 122.75,
            maxWidth: 122.75,
            cellRenderer: ({ data }: { data: Order }) => {
                return (
                    <>
                        <ActionButton actions={["edit"]} name="edit" data={data}>
                            <a
                                onClick={() => action("edit", data)}
                                title={startCase(formatMessage({ id: "common.action.edit" }))}
                                className="inline-action"
                            >
                                <KTSVG
                                    path="/media/icons/duotune/art/art005.svg"
                                    className="svg-icon-2"
                                />
                            </a>
                        </ActionButton>
                    </>
                );
            },
        },
    ];
}
